module.exports = __webpack_public_path__ + "img/stripe.079c1b37.svg";